<script lang="ts" setup>
import { Cell, CellGroup, Popup, Radio, RadioGroup } from "vant";
import { useAllVisibility } from "@/use/common";
import { Visibility } from "@/types/entity";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  show: boolean;
  visibility: Visibility;
}>();
const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
  (e: "update:visibility", value: Visibility): void;
}>();

const { t } = useI18n();
const VISIBILITIES = useAllVisibility();
</script>
<template>
  <popup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
    round
    safe-area-inset-bottom
    teleport="body"
  >
    <div class="h-full overflow-hidden grid grid-rows-[auto_1fr]">
      <div class="navbar bg-base-100 h-top-nav border-b">
        <!-- 左 -->
        <div class="navbar-start h-full"></div>
        <!-- 中 -->
        <div class="navbar-center">
          <div class="font-bold">{{ $t("SidebarNavi.setting") }}</div>
        </div>
        <!-- 右 -->
        <div class="navbar-end"></div>
      </div>
      <div class="flex flex-col bg-base-100 pb-4">
        <radio-group :model-value="props.visibility">
          <cell-group :title="t('Visibilities.visibilityTitle')" inset>
            <cell
              v-for="v in VISIBILITIES"
              :key="v.value"
              :title="v.text"
              clickable
              @click="emit('update:visibility', v.value)"
            >
              <template #right-icon>
                <Radio :name="v.value" />
              </template>
            </cell>
          </cell-group>
        </radio-group>
      </div>
    </div>
  </popup>
</template>
